/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  timber.cacheVariables();
  theme.mobileNav();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();

  
    theme.productImageGallery();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(370);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }

  theme.cache.$w.on('load', resizeElements);
  theme.cache.$w.on('resize', function () {
    afterResize(resizeElements, 250, 'equal-heights');
  });

  // Run once immediately in case the window load event has already fired.
  resizeElements();
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length || !$.fn.magnificPopup) {
    return;
  }

  var $galleryItems = theme.cache.$productImageGallery;

  function getPopupInstance() {
    return $.magnificPopup.instance;
  }

  function getLightboxContent(mfp) {
    if (!mfp || !mfp.wrap || !mfp.wrap.length) {
      return $();
    }

    return mfp.wrap.find('.mfp-content');
  }

  function normalizeLightboxOrder($content) {
    var $figure = $content.find('.mfp-figure').first();
    var $topbar = $content.find('.pf-lightbox-topbar').first();
    var $prev = $content.find('.pf-lightbox-nav--prev').first();
    var $next = $content.find('.pf-lightbox-nav--next').first();
    var $thumbs = $content.find('.pf-lightbox-thumbs').first();
    var $progress = $content.find('.pf-lightbox-progress').first();

    if (!$figure.length) {
      return;
    }

    /* Magnific may reinsert the new figure after our custom UI when
       changing slides. Re-establish the intended order without rebuilding
       any controls: topbar -> figure -> thumbnails -> progress.
       Navigation stays absolutely positioned inside the same shell. */
    if ($topbar.length) {
      $topbar.prependTo($content);
    }

    if ($prev.length) {
      $prev.appendTo($content);
    }

    if ($next.length) {
      $next.appendTo($content);
    }

    if ($thumbs.length) {
      $thumbs.insertAfter($figure);
    }

    if ($progress.length) {
      $progress.insertAfter($thumbs);
    }
  }

  var lightboxUpdateQueued = false;

  function updateLightboxUI() {
    var mfp = getPopupInstance();
    var $content = getLightboxContent(mfp);

    if (!$content.length) {
      return;
    }

    normalizeLightboxOrder($content);

    var total = $galleryItems.length;
    var currentIndex = Number(mfp.index || 0);

    $content
      .find('.pf-lightbox-count')
      .text((currentIndex + 1) + ' / ' + total);

    var $thumbs = $content.find('.pf-lightbox-thumb');

    $thumbs
      .removeClass('is-active')
      .attr('aria-selected', 'false')
      .eq(currentIndex)
      .addClass('is-active')
      .attr('aria-selected', 'true');

    var progress = total > 1 ? ((currentIndex + 1) / total) * 100 : 100;

    $content
      .find('.pf-lightbox-progress__bar')
      .css('width', progress + '%');

    /* Keep an off-screen active thumbnail visible without smooth scrolling.
       Smooth scroll during every slide change was contributing to the
       perceived jerking effect. */
    var rail = $content.find('.pf-lightbox-thumbs')[0];
    var activeThumb = $thumbs.eq(currentIndex)[0];

    if (rail && activeThumb) {
      var thumbLeft = activeThumb.offsetLeft;
      var thumbRight = thumbLeft + activeThumb.offsetWidth;
      var visibleLeft = rail.scrollLeft;
      var visibleRight = visibleLeft + rail.clientWidth;

      if (thumbLeft < visibleLeft) {
        rail.scrollLeft = thumbLeft;
      } else if (thumbRight > visibleRight) {
        rail.scrollLeft = thumbRight - rail.clientWidth;
      }
    }
  }

  function buildLightboxUI() {
    var mfp = getPopupInstance();
    var $content = getLightboxContent(mfp);

    if (!$content.length) {
      return;
    }

    mfp.wrap.addClass('pf-product-lightbox');
    $('.mfp-bg').addClass('pf-product-lightbox-bg');

    /* The Magnific content container persists between gallery images.
       Build our chrome once and only update its state afterwards. */
    if ($content.find('.pf-lightbox-topbar').length) {
      normalizeLightboxOrder($content);
      updateLightboxUI();
      return;
    }

    var total = $galleryItems.length;

    var $topbar = $('<div/>', {
      'class': 'pf-lightbox-topbar'
    });

    $('<div/>', {
      'class': 'pf-lightbox-count',
      'aria-live': 'polite'
    }).appendTo($topbar);

    var $closeButton = $(
      '<button type="button" class="pf-lightbox-close" aria-label="Close photo viewer">' +
        '<svg class="pf-lightbox-close-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>' +
      '</button>'
    );

    $closeButton.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      mfp.close();
    });

    $closeButton.appendTo($topbar);
    $topbar.appendTo($content);

    if (total > 1) {
      var $prev = $(
        '<button type="button" class="pf-lightbox-nav pf-lightbox-nav--prev" aria-label="Previous photo">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path d="M15 18l-6-6 6-6"></path>' +
          '</svg>' +
        '</button>'
      );

      var $next = $(
        '<button type="button" class="pf-lightbox-nav pf-lightbox-nav--next" aria-label="Next photo">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path d="M9 18l6-6-6-6"></path>' +
          '</svg>' +
        '</button>'
      );

      $prev.on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        mfp.prev();
      });

      $next.on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        mfp.next();
      });

      $prev.appendTo($content);
      $next.appendTo($content);
    }

    var $thumbRail = $('<div/>', {
      'class': 'pf-lightbox-thumbs',
      'role': 'tablist',
      'aria-label': 'Product photos'
    });

    $galleryItems.each(function(index) {
      var $item = $(this);
      var thumbSrc = $item.attr('data-thumb-src');
      var imageAlt = $item.attr('data-image-alt') || ('Product photo ' + (index + 1));

      if (!thumbSrc) {
        var imageId = $item.attr('data-image-id');
        thumbSrc = $('.pf-product-gallery__thumb[data-image-id="' + imageId + '"] img').attr('src') || '';
      }

      var $thumb = $('<button/>', {
        'type': 'button',
        'class': 'pf-lightbox-thumb',
        'role': 'tab',
        'aria-selected': 'false',
        'aria-label': 'View photo ' + (index + 1)
      });

      $('<img/>', {
        'src': thumbSrc,
        'alt': imageAlt,
        'loading': 'eager',
        'draggable': 'false'
      }).appendTo($thumb);

      $thumb.on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        if (index !== mfp.index) {
          mfp.goTo(index);
        }
      });

      $thumb.appendTo($thumbRail);
    });

    $thumbRail.appendTo($content);

    $(
      '<div class="pf-lightbox-progress" aria-hidden="true">' +
        '<span class="pf-lightbox-progress__bar"></span>' +
      '</div>'
    ).appendTo($content);

    normalizeLightboxOrder($content);
    updateLightboxUI();
  }

  $galleryItems.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade pf-product-lightbox',
    closeOnBgClick: true,
    closeBtnInside: true,
    showCloseBtn: false,
    closeOnContentClick: false,
    fixedContentPos: true,
    tClose: 'Close (Esc)',
    removalDelay: 220,

    image: {
      verticalFit: true,
      tError: 'The photo could not be loaded.'
    },

    callbacks: {
      open: function() {
        lightboxUpdateQueued = false;
        $('html').css('overflow-y', 'hidden');
        $('body').addClass('pf-product-lightbox-open');
        $('.mfp-bg').addClass('pf-product-lightbox-bg');

        window.setTimeout(buildLightboxUI, 0);
      },

      change: function() {
        /* Queue one layout/state update for the new slide. This keeps the
           figure in the correct place without rebuilding the gallery chrome. */
        if (!lightboxUpdateQueued) {
          lightboxUpdateQueued = true;

          window.requestAnimationFrame(function() {
            lightboxUpdateQueued = false;
            buildLightboxUI();
            updateLightboxUI();
          });
        }
      },

      imageLoadComplete: function() {
        /* Image completion can occur after Magnific swaps the figure node.
           Recheck order once, but do not rebuild or animate the rail. */
        if (!lightboxUpdateQueued) {
          lightboxUpdateQueued = true;

          window.requestAnimationFrame(function() {
            lightboxUpdateQueued = false;
            buildLightboxUI();
            updateLightboxUI();
          });
        }
      },

      close: function() {
        lightboxUpdateQueued = false;
        $('html').css('overflow-y', '');
        $('body').removeClass('pf-product-lightbox-open');
        $('.mfp-bg').removeClass('pf-product-lightbox-bg');
      }
    },

    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrows: false,
      preload: [1, 1],
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      tCounter: ''
    }
  });

  theme.cache.$productImage
    .off('click.pfProductLightbox')
    .on('click.pfProductLightbox', function() {
      var imageId = $(this).attr('data-image-id');

      $galleryItems
        .filter('[data-image-id="' + imageId + '"]')
        .trigger('click');
    });
};

theme.cartPage = function () {
  
    return;
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

 
$('.testimonial').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  adaptiveHeight: true
});
 

// Initialize theme's JS on docready
$(theme.init)
